import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// 🔧 FIX: Point to the 'components' folder
import BeforeAfterAlbum from './components/BeforeAfterAlbum'; 
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// axios.defaults.baseURL = 'http://139.59.253.58:3001';
console.log('✅ API configured to:', axios.defaults.baseURL);

const root = ReactDOM.createRoot(document.getElementById('root'));

// 🚦 SMART ROUTER LOGIC
if (window.location.pathname.includes('before-after.html')) {
    console.log("🚦 Routing to Before-After Album");
    root.render(
        // <React.StrictMode>
            <BeforeAfterAlbum />
        // </React.StrictMode>
    );
} else {
    console.log("🚦 Routing to Main OPD App");
    root.render(
        // <React.StrictMode>
            <App />
        // </React.StrictMode>
    );
}

reportWebVitals();